// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".num-students--numStudentsContainer--mAkSco5K {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin: 20px 0 16px 0;\n}\n.num-students--numStudentsContainer--mAkSco5K .num-students--numStudents--O8Nn8lJy {\n  width: 168px;\n  height: 30px;\n  border-radius: 15px 0px 0px 15px;\n  background-color: #f5fbfc;\n  color: #3f3f3f;\n}\n.num-students--numStudentsContainer--mAkSco5K .num-students--containerLabel--3WgECpCw {\n  font-weight: bold;\n  padding-left: 20px;\n}\n.num-students--numStudentsContainer--mAkSco5K .num-students--numStudents--O8Nn8lJy span {\n  position: relative;\n  line-height: 30px;\n}\n", ""]);
// Exports
exports.locals = {
	"numStudentsContainer": "num-students--numStudentsContainer--mAkSco5K",
	"numStudents": "num-students--numStudents--O8Nn8lJy",
	"containerLabel": "num-students--containerLabel--3WgECpCw"
};
module.exports = exports;
